import { createBrowserHistory } from 'history';
import type { LocationState } from 'types';

const history = createBrowserHistory<LocationState>();

export { history };
